import { Box, H3, H4, Spinner } from '@ouster/webviz-react-components';

export const StatisticBox = ({
  label,
  value,
  loading = false,
}: {
  label: string;
  value: string;
  loading?: boolean;
}) => (
  <Box
    flexGrow={1}
    display="grid"
    rowGap="4px"
    data-testid={`statistic-box-${label.toLowerCase().replace(/\s/g, '-')}`}
  >
    <H4 color="var(--color-unify-white-80)" fontSize="sm">
      {label ?? ''}
    </H4>
    <Box fontWeight={500} fontSize="2rem">
      {loading ? (
        <Box h={34} display="flex" alignItems="center">
          <Spinner />
        </Box>
      ) : (
        value
      )}
    </Box>
  </Box>
);

export const StatisticGroup = ({
  title,
  stats,
}: {
  title: string;
  stats: { label: string; value: string; loading?: boolean }[];
}) => (
  <Box
    p="1.5rem"
    border="1px solid var(--color-unify-white-40)"
    borderRadius={8}
    flexGrow={1}
    data-testid="statistic-group"
  >
    <H3 fontSize={18} mb={8} data-testid="statistic-group-title">
      {title}
    </H3>
    <Box display="flex" columnGap="1rem">
      {stats.map((stat) => (
        <StatisticBox
          key={stat.label}
          label={stat.label}
          value={stat.value}
          loading={stat.loading}
        />
      ))}
    </Box>
  </Box>
);
